module.exports = __webpack_public_path__ + "star-classic-chrome.a8f33d3bd3aa442c32bf.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/star-classic-chrome.svg
// module id = ../../../../../src/assets/img/star-classic-chrome.svg
// module chunks = main